<template>
  <div id="app">
    <Header />
    <modal name="contact-modal" height="auto" scrollable="true">
      <!-- :pivot-y="0.3" -->
      <div class="contact-modal__header">
        <h2>Informații contact</h2>
        <button @click="$modal.hide('contact-modal')">
          <font-awesome-icon icon="times" class="fas"></font-awesome-icon>
        </button>
      </div>
      <!-- End modal header -->
      <div class="contact-modal__body">
        <div class="contact-details">
          <ul class="contact-details__item justify-content-center">
            <li>
              <div class="icon-wrapper">
                <font-awesome-icon icon="user" class="fas"></font-awesome-icon>
              </div>
            </li>
            <li>
              <h4>Vânzări</h4>
            </li>
            <li class="text-center">
              <div class="user">
                <div class="user-name">
                  <font-awesome-icon icon="name" class="fas"></font-awesome-icon>
                  <strong>Bumb Radu</strong>
                </div>
                <div class="user-phone">
                  <a href="tel:0754094617">
                    <font-awesome-icon icon="phone" class="fas"></font-awesome-icon>0754 094 617
                  </a>
                </div>
                <div class="user-email">
                  <a href="mailto:radudiafanis@gmail.com">
                    <font-awesome-icon icon="envelope" class="fas"></font-awesome-icon>radudiafanis@gmail.com
                  </a>
                </div>
              </div>
            </li>
          </ul>
          <!-- End contact details item -->
          <ul class="contact-details__item">
            <li>
              <div class="icon-wrapper">
                <font-awesome-icon icon="info" class="fas"></font-awesome-icon>
              </div>
            </li>
            <li>
              <h4>Detalii firmă</h4>
            </li>
            <li>
              <strong>Sediul social</strong>
              <p>BISTRIŢA, STR. DORNEI, NR 27</p>
            </li>
            <li>
              <strong>Cod poștal</strong>
              <p>420032</p>
            </li>
            <li>
              <strong>Nr. Reg. Com.</strong>
              <p>J06/571/1997</p>
            </li>
            <li>
              <strong>C.I.F.</strong>
              <p>RO 10047531</p>
            </li>
            <li>
              <strong>Cont</strong>
              <p>RO35 BTRL RON CRT 0207214501</p>
            </li>
            <li>
              <strong>Banca</strong>
              <p>Transilvania</p>
            </li>
          </ul>
          <!-- End contact details item -->
        </div>
        <!-- End contact details -->
      </div>
      <!-- End modal body -->
    </modal>
    <!-- End modal -->
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/layouts/Header.vue";
import Footer from "./components/layouts/Footer.vue";

export default {
  name: "app",
  // metaInfo: {
  //   title: 'Acoperis Expert',
  //   meta: [
  //     {'http-equiv':'X-UA-Compatible', content:'IE=edge'},
  //     { name: 'viewport', content: 'width=device-width, initial-scale=1' }
  //   ]
  // },
  components: {
    Header,
    Footer
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue